import { render, staticRenderFns } from "./MultipleOrgan.vue?vue&type=template&id=62cfcbe7"
import script from "./MultipleOrgan.vue?vue&type=script&lang=js"
export * from "./MultipleOrgan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports